import { BadgeButton } from "app/components/atoms/button";
import { SearchInput } from "app/components/atoms/input";
import { FormHeader } from "app/components/atoms/layout";
import Table from "app/components/atoms/table";
import { useNavigate } from "react-router-dom";

function CustomerPageTable({
  suppliers,
  onDeleteCustomerClick = () => {},
  query = "",
  onQueryChange = () => {},
}) {
  const navigate = useNavigate();

  return (
    <Table.Container>
      <Table.UtilitiesWrapper>
        <Table.SearchBarWrapper>
          <FormHeader appearance="none">
            <SearchInput
              placeholder="Cari Supplier"
              type="text"
              value={query}
              onChange={onQueryChange}
            />
          </FormHeader>
        </Table.SearchBarWrapper>
        {/* <Table.UtilitiesButtonWrapper>
          <IconButton icon={PrinterIcon} />
        </Table.UtilitiesButtonWrapper> */}
      </Table.UtilitiesWrapper>
      <Table.Wrapper asIndex={true}>
        <Table.Header>
          <Table.HeaderRow>
            <Table.Heading>Nama Lengkap</Table.Heading>
            <Table.Heading>Kontak</Table.Heading>
            {/* <Table.Heading align="right">Kredit</Table.Heading> */}
            <Table.Heading></Table.Heading>
          </Table.HeaderRow>
        </Table.Header>
        <Table.Body>
          {suppliers?.map((supplier, key) => (
            <Table.BodyRow key={key}>
              <Table.Cell size="sm">
                <p>
                  {supplier?.firstName} {supplier?.middleName}{" "}
                  {supplier?.lastName}
                </p>
              </Table.Cell>
              <Table.Cell size="sm">
                <div className="block">
                  <p>{supplier.phone}</p>
                  <p className="text-xs text-gray-400 font-light">
                    {supplier.email}
                  </p>
                </div>
              </Table.Cell>
              {/* <Table.Cell size="sm" align="right">
                <Typography.Currency number={supplier.credit} />
              </Table.Cell> */}
              <Table.Cell size="sm">
                <div className="flex">
                  <BadgeButton
                    onClick={(e) => navigate("detail/" + supplier.id)}
                  >
                    View
                  </BadgeButton>
                  {/* <IconButton
                    icon={TrashIcon}
                    onClick={(e) => onDeleteCustomerClick(supplier.id)}
                  /> */}
                </div>
              </Table.Cell>
            </Table.BodyRow>
          ))}
        </Table.Body>
      </Table.Wrapper>
    </Table.Container>
  );
}

export default CustomerPageTable;
